module.exports = __webpack_public_path__ + "static/media/plus_heart_gradient.3207edee.svg";